import type { ProcessedCourse } from "@/common/course/types";

/**
 * A program is considered retired when it has at least one course and
 * every one of its courses has only archived course runs.
 *
 * `ProcessedCourse.onlyArchivedCourseRuns` is `true` for a course whose
 * `courseRuns` array is empty, so we additionally require each course to
 * have at least one run to avoid false positives from malformed data.
 */
export default function isProgramRetired(
  courses: ProcessedCourse[] | null | undefined,
): boolean {
  if (!courses || courses.length === 0) return false;

  return courses.every(
    (course) =>
      Boolean(course?.onlyArchivedCourseRuns) &&
      (course?.courseRuns?.length ?? 0) > 0,
  );
}
